import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import translate from "../../../../src/i18n/translate";

export default function InsightsFooter(): JSX.Element {
  const fullYear = new Date().getUTCFullYear().toString();
  const copyrightMessage = useIntl().formatMessage(
    { id: "app.footer.rightsReservedText" },
    { fullYearValue: fullYear }
  );
  return (
    <footer className="footer maincontentfooter">
      <div className="copyright">&copy; {copyrightMessage}</div>
      <div className="footernav">
        <ul className="nobullets">
          <li>
            <Link className="footerlink" to="/insights/sitemap">
              {translate("app.footer.siteMap")}
            </Link>
          </li>
          <li>
            <a
              className="footerlink"
              href="https://www.watermarkinsights.com/terms/"
              target="_blank"
            >
              {translate("app.footer.termsAndConditions")}
            </a>
          </li>
          <li>
            <a
              className="footerlink"
              href="https://www.watermarkinsights.com/privacy-policy/"
              target="_blank"
            >
              {translate("app.footer.privacyPolicy")}
            </a>
          </li>
          <li>
            <a
              className="footerlink"
              href="https://www.watermarkinsights.com/accessibility/"
              target="_blank"
            >
              {translate("app.footer.accessibilityPolicy")}
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
